import React, {useEffect} from 'react';
import {Form, Formik} from "formik";
import {
    Grid,
    withStyles
} from "@material-ui/core";
import * as PropTypes from "prop-types";
import style from "./styles";
import {GetActionsButtons} from "./utils";

function Index(Props) {
    const {classes, schema, data, initialValue = {}, initialState = {}, ...props} = Props;
    return <Formik key={'formik'}
                   initialValues={initialValue}
                   validateOnMount={false}
                   onSubmit={(values, actions) => {
                       props.onSubmit(data, values);
                       if (!props.disableCloseOnSubmit)
                           props.onCancel();
                   }}>
        {
            form => {
                useEffect(() => {
                    form.setValues(data)
                }, [])
                const schemaFrm = schema(form);
                return <Form
                    onKeyDown={e => {
                        e.persist()
                        if(form.isSubmitting)
                            return e.preventDefault();
                        if ((e.charCode || e.keyCode) === 13)
                            e.preventDefault();
                        if((e.charCode || e.keyCode) === 13 && e.ctrlKey && !schemaFrm?.noCtrlSubmit)
                            form.handleSubmit()
                    }}
                    className={classes.tagForm}
                >
                    <Grid
                        key={'fields'}
                        container
                        justifyContent={'flex-start'}
                        direction={'row'}
                        className={classes.spacing}
                        spacing={1}>
                        {
                            Props.children(form, props)
                        }
                    </Grid>
                    {
                        schemaFrm.actions?.length &&
                        <Grid key={'actions-buttons'}
                              container
                              justifyContent={'flex-end'}
                              direction={'row'}
                              className={classes.spacingActions}
                              spacing={5}>
                            {
                                GetActionsButtons(schemaFrm.actions, form, props, initialState)
                            }
                        </Grid>
                    }
                </Form>
            }
        }
    </Formik>
}


Index.propTypes = {
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    disableCloseOnSubmit: PropTypes.bool,
    autoFocus: PropTypes.bool,
};

Index.defaultProps = {
    onSubmit: () => {
    },
    onCancel: () => {
    },
    disableCloseOnSubmit: false,
    autoFocus: false,
};


export default withStyles(style)(Index);




